export default "/images/9916af9731c2d4dac56fbb69e3f5d5d2.avif";